// removed by extract-text-webpack-plugin
module.exports = {"link":"general__link___2uaDd cursor-pointer textDecoration-none transitionDuration-m transitionProperty-all transitionTimingFunction-linear","isDisabled":"general__isDisabled___13hDh pointerEvents-none userSelect-none"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-link/Link/style/general.css
// module id = 17
// module chunks = 0 4 5 7 20